<template>
  <div>
    <h6 style="margin: 10px !important">{{ STOKADI }}</h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      STOKADI: "",
    };
  },
  methods: {
    gelenData() {
      this.STOKADI = this.params.data.STOCKNAME;
    },
   
  },
  created() {
    this.gelenData();
  },
};
</script>
